module.exports = __webpack_public_path__ + "img/sofortuber.bba9d251.svg";